import React from 'react';

const Play = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 16"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Homepage" transform="translate(-648, -362)" fill="currentColor">
        <g id="Group-Copy" transform="translate(609, 327)">
          <polygon
            id="Triangle"
            transform="translate(45.6, 43) rotate(-270) translate(-45.6, -43)"
            points="45.6 37 53.2 49 38 49"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export default Play;